import React, { useContext } from "react"
import { Fragment } from "react"
import { HelpCenterContext } from "./Context/HelpCenterContext"

export const BottomSection = () => {
    const { state, dispatch } = useContext(HelpCenterContext)
    return (
        <Fragment>
            {
                !state.showContactUsOptions &&
                <div className="bottom-section">
                    {(state.user.rating === "0" && state.user.remindMelaterForRating === "false") ?
                        <button onClick={() => dispatch({ type: "TOGGLE_RATING_DIALOG" })} type="button" className="btn btn-link mt-auto me-2 text-decoration-none text-primary"><i className="fa-solid fa-thumbs-up me-2"></i>Provide Feedback</button>
                        :
                        <button onClick={() => dispatch({ type: "TOGGLE_SUBMITIDEA_DIALOG" })} type="button" className="btn btn-link mt-auto me-2 text-decoration-none text-primary"><i className="fa-solid fa-lightbulb-on me-2"></i>Submit Idea</button>
                    }
                    <button onClick={() => dispatch({ type: "TOGGLE_CONTACTUS_OPTIONS" })} type="button" className="btn btn-primary mt-auto">Contact us</button>
                </div>
            }
        </Fragment>
    )
}